import { useEffect, useState } from 'react';
import CvDocumentIcon from '../components/clients/CvDocumentIcon';
import './AdditionalDocuments.css';

export function isAdditionalDocument(file) {
  const key = String(file?.review?.requirementKey || file?.requirementKey || '');
  return file?.intakeCategory === 'cv' || /^(party[:|][^:|]+[:|]cv|additional[:|].+)$/.test(key);
}

export function additionalDocumentsFromSubmissions(submissions) {
  const seen = new Set();
  return submissions.flatMap(submission => (submission.files || []).map(file => ({ ...file, __submissionId: submission.id })))
    .filter(file => {
      if (!file.objectPath || !isAdditionalDocument(file) || seen.has(file.objectPath)) return false;
      seen.add(file.objectPath);
      return true;
    });
}

function AdditionalDocumentRow({ file, index, clientId, loadFile, onPreview, onDelete, readOnly, deleting }) {
  const [src, setSrc] = useState('');
  const isCv = file.intakeCategory === 'cv' || /[:|]cv$/.test(file.review?.requirementKey || file.requirementKey || '');
  const label = isCv ? 'CV' : file.review?.requirementText || file.cardTitle || 'Document';
  useEffect(() => {
    let active = true;
    let url = '';
    setSrc('');
    loadFile(file, clientId).then(value => {
      url = value;
      if (active) setSrc(value);
      else if (url?.startsWith('blob:')) URL.revokeObjectURL(url);
    }).catch(() => { if (active) setSrc(''); });
    return () => { active = false; if (url?.startsWith('blob:')) URL.revokeObjectURL(url); };
  }, [file, clientId, loadFile]);

  return <li>
    <span className="kycAdditionalNumber" aria-label={`Document ${index + 1}`}>{index + 1}</span>
    <button type="button" className="kycAdditionalType" onClick={() => onPreview(file)} aria-label={`Preview ${label}`} title={`Preview ${label}`}>
      {isCv ? <CvDocumentIcon /> : <i className="bi bi-file-earmark-text" aria-hidden="true" />}<span>{isCv ? 'Curriculum Vitae' : label}</span>
    </button>
    <div className="kycAdditionalActions">
      <a href={src || undefined} download={file.originalName || `${label}.pdf`} aria-label={`Download ${label}`} title={`Download ${label}`} aria-disabled={!src} tabIndex={src ? 0 : -1} onClick={event => { if (!src) event.preventDefault(); }}><i className="bi bi-download" aria-hidden="true" /></a>
      {!readOnly && <button type="button" disabled={deleting} onClick={() => onDelete(file)} aria-label={`Delete ${label}`} title={`Delete ${label}`}><i className="bi bi-trash" aria-hidden="true" /></button>}
    </div>
  </li>;
}

export default function AdditionalDocuments({ files, clientId, loadFile, onPreview, onDelete, readOnly, deleting }) {
  if (!files.length) return null;
  return <section className="kycSubSection kycSubCard kycAdditionalDocuments" aria-label="Other documents">
    <div className="kycSubSectionTitle">3. Other documents</div>
    <div className="kycSubSectionHint text-muted small">Optional documents providing further information about the client</div>
    <ul>{files.map((file, index) => <AdditionalDocumentRow key={file.objectPath} {...{file, index, clientId, loadFile, onPreview, onDelete, readOnly, deleting}} />)}</ul>
  </section>;
}
